import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 38000-38999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const viewsErrors = {
  // 38xxx is the views module's series. Two sites stay generic.
  // 38001-38006 — the views module's split.
  VIEW_WRITE_FAILED: {
    errorCode: 38001,
    errorMessage: t("The view could not be written to the database."),
    isDynamic: false,
  },
  VIEW_NONE_FOR_FILE: {
    errorCode: 38002,
    errorMessage: t("No views exist for this file."),
    isDynamic: false,
  },
  VIEW_TO_SET_DEFAULT_NOT_FOUND: {
    errorCode: 38003,
    errorMessage: t("The view to set as default no longer exists."),
    isDynamic: false,
  },
  // 38004/38005 are different facts: no default is configured at all, versus a default that points
  // at a view which no longer exists.
  VIEW_NO_DEFAULT_SET: {
    errorCode: 38004,
    errorMessage: t("No default view is set for this file."),
    isDynamic: false,
  },
  VIEW_DEFAULT_TARGET_NOT_FOUND: {
    errorCode: 38005,
    errorMessage: t("The view referenced as this file's default no longer exists."),
    isDynamic: false,
  },
  VIEW_OR_FOLDER_UPDATE_FAILED: {
    errorCode: 38006,
    errorMessage: t("The view or folder could not be updated."),
    isDynamic: false,
  },
  // 38007-38010: the same upload-permission refusal, but each sentence names the operation it
  // blocked, so each keeps its own code rather than collapsing to INSUFFICIENT_PERMISSION.
  VIEW_SAVE_NO_UPLOAD_PERMISSION: {
    errorCode: 38007,
    errorMessage: t("You do not have upload permission on this file, so the view was not saved."),
    isDynamic: false,
  },
  VIEW_DELETE_NO_UPLOAD_PERMISSION: {
    errorCode: 38008,
    errorMessage: t("You do not have upload permission on this file, so the view was not deleted."),
    isDynamic: false,
  },
  VIEW_DEFAULT_CHANGE_NO_UPLOAD_PERMISSION: {
    errorCode: 38009,
    errorMessage: t("You do not have upload permission on this file, so the default view was not changed."),
    isDynamic: false,
  },
  VIEW_OR_FOLDER_UPDATE_NO_UPLOAD_PERMISSION: {
    errorCode: 38010,
    errorMessage: t("You do not have upload permission on this file, so the view or folder was not updated."),
    isDynamic: false,
  },
  VIEW_FOLDER_FILE_VERSION_REQUIRED: {
    errorCode: 38011,
    errorMessage: t("A file version is required to create a view folder."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
